import React from 'react'
import Layout from '../components/layouts/Layout'
import ContactHero from '../modules/sections/contact/ContactHero'

export const ContactUs = () => {
  return (
    <div>
      <Layout>
        <ContactHero></ContactHero>
      </Layout>
    </div>
  )
}
